import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as APIActions from '../+state/actions/api.actions';
import * as AEMActions from '../+state/actions/content.actions';
import * as CommonSelectors from '../+state/selectors/common.selectors';
import * as EarnsSelectors from '../+state/selectors/earns.selectors';
import * as OverviewSelectors from '../+state/selectors/overview.selectors';
import * as SummarySelectors from '../+state/selectors/summary.selectors';
import { TrackerFacade } from '../../data-access/facades/tracker.facade';
import { StateFacade as ContentFacade } from './content.facade';

@Injectable({
  providedIn: 'root'
})
export class StateFacade {
  welcomeTour$ = this.store.pipe(select(OverviewSelectors.getWelcomeTour));
  welcomeTourFlag$ = this.store.pipe(
    select(OverviewSelectors.getWelcomeTourFlag)
  );

  overviewState$ = this.store.pipe(select(CommonSelectors.getOverviewState));
  onboarding$ = this.store.pipe(select(CommonSelectors.getOnboarding));
  microMoments$ = this.store.pipe(select(OverviewSelectors.getMicroMoments));
  header$ = this.store.pipe(select(OverviewSelectors.getHeader));
  summary$ = this.store.pipe(select(SummarySelectors.getSummary));

  trackerContent$ = this.store.pipe(select(SummarySelectors.getTrackerContent));
  futureActivityRequest$ = this.store.pipe(
    select(SummarySelectors.getFutureActivityRequest)
  );

  status$ = this.store.pipe(select(SummarySelectors.getStatus));
  cards$ = this.store.pipe(select(SummarySelectors.getCards));
  quickLinks$ = this.store.pipe(select(OverviewSelectors.getQuickLinks));
  benefits$ = this.store.pipe(select(OverviewSelectors.getBenefits));
  snapshot$ = this.store.pipe(select(OverviewSelectors.getSnapshot));
  upgrades$ = this.store.pipe(select(OverviewSelectors.getUpgrades));
  title$ = this.store.pipe(select(EarnsSelectors.getEarnsTitle));
  banner$ = this.store.pipe(select(EarnsSelectors.getBanner));
  offers$ = this.store.pipe(select(EarnsSelectors.getOffers));
  partners$ = this.store.pipe(select(EarnsSelectors.getPartnersFlag));
  relatedLinks$ = this.store.pipe(select(EarnsSelectors.getRelatedLinks));
  stipulation$ = this.store.pipe(select(OverviewSelectors.getStipulation));
  carrierCode$ = this.store.pipe(select(CommonSelectors.getCarrierCode));
  peRequest$ = this.store.pipe(select(OverviewSelectors.getPERequest));
  eDocsRequest$ = this.store.pipe(select(OverviewSelectors.getEdocsRequest));
  earnsSummary$ = this.store.pipe(select(SummarySelectors.getEarnsSummary));

  skyclubRequest$ = this.store.pipe(
    select(OverviewSelectors.getSkyClubRequest)
  );

  skyclubTracker$ = this.store.pipe(select(SummarySelectors.getSkyClubTracker));

  serviceConfiguration$ = this.store.pipe(
    select(CommonSelectors.getServiceConfiguration)
  );

  fullPageError$ = this.store.pipe(
    select(CommonSelectors.getFullPageErrorMessage)
  );

  flags$ = this.store.pipe(select(CommonSelectors.getFlags));

  constructor(
    private readonly store: Store,
    public content: ContentFacade,
    public tracker: TrackerFacade
  ) {}

  init() {
    this.content.init();
    this.tracker.init(false);
    this.store.dispatch(AEMActions.loadAEMWelcomeTour());
    this.store.dispatch(APIActions.loadMultiplePE());
    this.store.dispatch(APIActions.loadVouchers());
    this.store.dispatch(APIActions.loadEDocs());
    this.store.dispatch(APIActions.loadSnapshot());
    this.store.dispatch(APIActions.loadEarnsSummary());
    this.store.dispatch(APIActions.loadSkyClubTracker());
  }
}
